import emptyState from '../../../../../assets/empty-state.svg';
import { useCustomTranslation } from '../../../../hooks';

export const SearchAbove = () => {
  const { tWrapper } = useCustomTranslation('products.productionPlan');
  return (
    <div className="flex h-full flex-col items-center justify-center gap-4">
      <div className="h-70 w-70 bg-contain bg-center bg-no-repeat" style={{ backgroundImage: `url(${emptyState})` }} />
      <span className="text-s18">{tWrapper('searchAbove')}</span>
    </div>
  );
};
